var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-picker',{attrs:{"title":"切换订单列表","data":_vm.orderData,"value":_vm.currentOrder,"confirm-on-pick":""},on:{"input":_vm.handleOrderChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var label = ref.label;
return [_c('div',{class:_vm._.trigger},[_vm._v(" "+_vm._s(label)+" "),_c('van-icon',{class:_vm._.down,attrs:{"name":"arrow-down"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }